import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Home, 
  CreditCard, 
  PieChart, 
  BarChart3, 
  Settings,
  Tag
} from 'lucide-react';
import { cn } from '../../utils/cn';

const navigation = [
  { name: 'Home', href: '/', icon: Home },
  { name: 'Expenses', href: '/expenses', icon: CreditCard },
  { name: 'Budget', href: '/budget', icon: PieChart },
  { name: 'Analytics', href: '/analytics', icon: BarChart3 },
  { name: 'Tags', href: '/analytics/tags', icon: Tag },
  { name: 'Settings', href: '/settings', icon: Settings },
];

const MobileNav = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <nav className="flex">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            end={item.href === '/analytics'} // Use exact matching for Analytics
            className={({ isActive }) =>
              cn(
                'flex-1 flex flex-col items-center justify-center py-2 px-0.5 text-xs font-medium transition-colors',
                isActive
                  ? 'text-primary bg-primary/5'
                  : 'text-gray-500 hover:text-gray-700'
              )
            }
          >
            {({ isActive }) => (
              <>
                <item.icon
                  className={cn(
                    'h-5 w-5 mb-0.5',
                    isActive ? 'text-primary' : 'text-gray-400'
                  )}
                />
                <span className={cn(
                  'text-xs leading-tight',
                  isActive ? 'text-primary' : 'text-gray-500'
                )}>
                  {item.name}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default MobileNav;

